module.exports = __webpack_public_path__ + "static/img/bg-id.6eb7aae8.webp";